import classNames from 'classnames';
import { useRouter } from 'next/router';
import CloseIcon from 'public/images/common/close.svg';
import React, { useContext } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { BaseButton } from 'src/components/shared/elements/buttons/BaseButton';
import { WAmazingIcon } from 'src/components/shared/elements/icons/WAmazingIcon';
import { OnlyInMobile } from 'src/components/shared/layouts/Responsive';
import { I18nContext } from 'src/stores/I18n';
import { checkLocaleEn } from 'src/utils/locale';
import styles from './index.module.scss';

type Props = {
  title: string | React.JSX.Element | React.JSX.Element[];
  downloadText: string;
  handleClose: () => void;
  handleDownloadButtonClick: () => void;
};

export const Presenter: React.FC<Props> = ({ title, downloadText, handleClose, handleDownloadButtonClick }) => {
  const localeResources = useContext(I18nContext);
  const { locale } = useRouter();
  return (
    <OnlyInMobile className={styles.appBannerWrap}>
      <div className={styles.container}>
        <div className={styles.closeIconContainer} onClick={handleClose}>
          <NextImage src={CloseIcon} alt={localeResources.commons.dismiss} width={8} height={8} />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.logoContainer}>
            <WAmazingIcon className="w-10 h-10" />
          </div>
          <div className={styles.titleContainer}>
            <p className={classNames(styles.title, { [styles.en]: checkLocaleEn(locale) })}>{title}</p>
          </div>
          <div className={styles.downloadButtonContainer}>
            <BaseButton
              text={downloadText}
              externalLink="https://app.adjust.com/15fy5gka"
              target="_blank"
              rel="noreferrer noopener"
              isBlueButton
              width="max-content"
              fontSize={14}
              onClick={handleDownloadButtonClick}
            />
          </div>
        </div>
      </div>
    </OnlyInMobile>
  );
};
